type Language = 'sl' | 'en' | 'fr' | 'de' | 'it' | 'uk' | 'ru';

type TranslationKey = string;
type Translations = Record<Language, string>;

export const translations: Record<TranslationKey, Translations> = {
  // Services Page
  'services.title': {
    sl: 'Naše storitve',
    en: 'Our Services',
    fr: 'Nos Services',
    de: 'Unsere Dienstleistungen',
    it: 'I Nostri Servizi',
    uk: 'Наші Послуги',
    ru: 'Наши Услуги',
  },
  'services.hero': {
    sl: 'Doživite čebelarstvo z vsemi čutili',
    en: 'Experience Beekeeping with All Senses',
    fr: "Découvrez l'Apiculture avec Tous les Sens",
    de: 'Erleben Sie Imkerei mit allen Sinnen',
    it: "Vivi l'Apicoltura con Tutti i Sensi",
    uk: 'Відчуйте Бджільництво Всіма Почуттями',
    ru: 'Ощутите Пчеловодство Всеми Чувствами',
  },
  'services.booking.title': {
    sl: 'Rezervirajte apiterapijo',
    en: 'Book Apitherapy',
    fr: "Réserver l'Apithérapie",
    de: 'Apitherapie Buchen',
    it: 'Prenota Apiterapia',
    uk: 'Забронювати Апітерапію',
    ru: 'Забронировать Апитерапию',
  },
  'services.testimonials.title': {
    sl: 'Mnenja naših gostov',
    en: 'Guest Testimonials',
    fr: 'Témoignages des Clients',
    de: 'Gästebewertungen',
    it: 'Testimonianze degli Ospiti',
    uk: 'Відгуки Гостей',
    ru: 'Отзывы Гостей',
  },
  'services.cta.title': {
    sl: 'Rezervirajte svoj termin še danes',
    en: 'Book Your Appointment Today',
    fr: "Réservez Votre Rendez-vous Aujourd'hui",
    de: 'Buchen Sie Ihren Termin Heute',
    it: 'Prenota il Tuo Appuntamento Oggi',
    uk: 'Забронюйте Зустріч Сьогодні',
    ru: 'Забронируйте Встречу Сегодня',
  },
  'services.cta.description': {
    sl: 'Doživite naravno zdravljenje in sprostitev v naši čebelariji.',
    en: 'Experience natural healing and relaxation at our beekeeping.',
    fr: 'Découvrez les soins naturels et la détente dans notre apiculture.',
    de: 'Erleben Sie natürliche Heilung und Entspannung in unserer Imkerei.',
    it: 'Vivi la guarigione naturale e il relax nella nostra apicoltura.',
    uk: 'Відчуйте природне лікування та релаксацію в нашому пасіці.',
    ru: 'Ощутите естественное исцеление и расслабление на нашей пасеке.',
  },
  'services.cta.button': {
    sl: 'Rezerviraj apiterapijo',
    en: 'Book Apitherapy',
    fr: "Réserver l'Apithérapie",
    de: 'Apitherapie Buchen',
    it: 'Prenota Apiterapia',
    uk: 'Забронювати Апітерапію',
    ru: 'Забронировать Апитерапию',
  },

  // Products Page
  'products.title': {
    sl: 'Naši izdelki',
    en: 'Our Products',
    fr: 'Nos Produits',
    de: 'Unsere Produkte',
    it: 'I Nostri Prodotti',
    uk: 'Наші Продукти',
    ru: 'Наши Продукты',
  },
  'products.hero': {
    sl: 'Naravni, lokalni, z ljubeznijo narejeni',
    en: 'Natural, Local, Made with Love',
    fr: 'Naturel, Local, Fait avec Amour',
    de: 'Natürlich, Lokal, Mit Liebe Gemacht',
    it: 'Naturale, Locale, Fatto con Amore',
    uk: "Натуральні, Місцеві, Зроблені з Любов'ю",
    ru: 'Натуральные, Местные, Сделанные с Любовью',
  },
  'products.quality.title': {
    sl: 'Zagotovilo kakovosti',
    en: 'Quality Assurance',
    fr: 'Garantie de Qualité',
    de: 'Qualitätssicherung',
    it: 'Garanzia di Qualità',
    uk: 'Гарантія Якості',
    ru: 'Гарантия Качества',
  },
  'products.quality.description': {
    sl: 'Vsi naši izdelki so naravni, brez dodatkov, certificirani po slovenskih standardih. Vsak kozarec medu je rezultat skrbnega dela in spoštovanja do narave.',
    en: 'All our products are natural, additive-free, certified according to Slovenian standards. Every jar of honey is the result of careful work and respect for nature.',
    fr: "Tous nos produits sont naturels, sans additifs, certifiés selon les normes slovènes. Chaque pot de miel est le résultat d'un travail minutieux et du respect de la nature.",
    de: 'Alle unsere Produkte sind natürlich, ohne Zusatzstoffe, nach slowenischen Standards zertifiziert. Jedes Honigglas ist das Ergebnis sorgfältiger Arbeit und Respekt vor der Natur.',
    it: 'Tutti i nostri prodotti sono naturali, senza additivi, certificati secondo gli standard sloveni. Ogni vasetto di miele è il risultato di un lavoro attento e rispetto per la natura.',
    uk: 'Всі наші продукти натуральні, без добавок, сертифіковані за словенськими стандартами. Кожна банка меду - результат ретельної роботи та поваги до природи.',
    ru: 'Все наши продукты натуральные, без добавок, сертифицированы по словенским стандартам. Каждая банка меда - результат тщательной работы и уважения к природе.',
  },
  'products.natural': {
    sl: '100% Naravno',
    en: '100% Natural',
    fr: '100% Naturel',
    de: '100% Natürlich',
    it: '100% Naturale',
    uk: '100% Натуральне',
    ru: '100% Натуральное',
  },
  'products.certified': {
    sl: 'Certificirano',
    en: 'Certified',
    fr: 'Certifié',
    de: 'Zertifiziert',
    it: 'Certificato',
    uk: 'Сертифіковано',
    ru: 'Сертифицировано',
  },
  'products.local': {
    sl: 'Lokalno',
    en: 'Local',
    fr: 'Local',
    de: 'Lokal',
    it: 'Locale',
    uk: 'Місцеве',
    ru: 'Местное',
  },
  'products.visit.title': {
    sl: 'Obiščite našo čebelarijo za osebni nakup',
    en: 'Visit Our Beekeeping for Personal Purchase',
    fr: 'Visitez Notre Apiculture pour un Achat Personnel',
    de: 'Besuchen Sie Unsere Imkerei für Persönlichen Einkauf',
    it: 'Visita la Nostra Apicoltura per Acquisto Personale',
    uk: 'Відвідайте Нашу Пасіку для Особистої Покупки',
    ru: 'Посетите Нашу Пасеку для Личной Покупки',
  },
  'products.visit.description': {
    sl: 'Za več informacij in naročila nas kontaktirajte.',
    en: 'For more information and orders, contact us.',
    fr: "Pour plus d'informations et commandes, contactez-nous.",
    de: 'Für weitere Informationen und Bestellungen kontaktieren Sie uns.',
    it: 'Per ulteriori informazioni e ordini, contattaci.',
    uk: "Для отримання додаткової інформації та замовлень зв'яжіться з нами.",
    ru: 'Для получения дополнительной информации и заказов свяжитесь с нами.',
  },

  // Blog Page
  'blog.title': {
    sl: 'Blog',
    en: 'Blog',
    fr: 'Blog',
    de: 'Blog',
    it: 'Blog',
    uk: 'Блог',
    ru: 'Блог',
  },
  'blog.subtitle': {
    sl: 'Novice, nasveti in zgodbe iz sveta čebelarstva',
    en: 'News, tips and stories from the world of beekeeping',
    fr: "Actualités, conseils et histoires du monde de l'apiculture",
    de: 'Neuigkeiten, Tipps und Geschichten aus der Welt der Imkerei',
    it: "Notizie, consigli e storie dal mondo dell'apicoltura",
    uk: 'Новини, поради та історії зі світу бджільництва',
    ru: 'Новости, советы и истории из мира пчеловодства',
  },

  // Contact Page
  'contact.title': {
    sl: 'Kontaktirajte nas',
    en: 'Contact Us',
    fr: 'Contactez-nous',
    de: 'Kontaktieren Sie Uns',
    it: 'Contattaci',
    uk: "Зв'яжіться з Нами",
    ru: 'Свяжитесь с Нами',
  },
  'contact.hero': {
    sl: 'Smo vam na voljo',
    en: 'We Are Here for You',
    fr: 'Nous Sommes Là pour Vous',
    de: 'Wir Sind für Sie Da',
    it: 'Siamo Qui per Te',
    uk: 'Ми Тут для Вас',
    ru: 'Мы Здесь для Вас',
  },
  'contact.description': {
    sl: 'Pošljite nam poizvedbo za rezervacije apiterapije, naročila izdelkov ali splošne poslovne informacije. Odgovorili vam bomo v 24 urah.',
    en: 'Send us an inquiry for apitherapy bookings, product orders, or general business information. We will respond within 24 hours.',
    fr: "Envoyez-nous une demande pour des réservations d'apithérapie, des commandes de produits ou des informations commerciales générales. Nous vous répondrons dans les 24 heures.",
    de: 'Senden Sie uns eine Anfrage für Apitherapie-Buchungen, Produktbestellungen oder allgemeine Geschäftsinformationen. Wir werden innerhalb von 24 Stunden antworten.',
    it: 'Inviaci una richiesta per prenotazioni di apiterapia, ordini di prodotti o informazioni commerciali generali. Risponderemo entro 24 ore.',
    uk: 'Надішліть нам запит на бронювання апітерапії, замовлення продуктів або загальну бізнес-інформацію. Ми відповімо протягом 24 годин.',
    ru: 'Отправьте нам запрос на бронирование апитерапии, заказы продуктов или общую бизнес-информацию. Мы ответим в течение 24 часов.',
  },
  'contact.phone': {
    sl: 'Telefon',
    en: 'Phone',
    fr: 'Téléphone',
    de: 'Telefon',
    it: 'Telefono',
    uk: 'Телефон',
    ru: 'Телефон',
  },
  'contact.email': {
    sl: 'Email',
    en: 'Email',
    fr: 'Email',
    de: 'E-Mail',
    it: 'Email',
    uk: 'Електронна Пошта',
    ru: 'Электронная Почта',
  },
  'contact.location': {
    sl: 'Lokacija',
    en: 'Location',
    fr: 'Emplacement',
    de: 'Standort',
    it: 'Posizione',
    uk: 'Розташування',
    ru: 'Местоположение',
  },
  'contact.address': {
    sl: 'Pod goroj 57, 2342 Ruše',
    en: 'Pod goroj 57, 2342 Ruše',
    fr: 'Pod goroj 57, 2342 Ruše',
    de: 'Pod goroj 57, 2342 Ruše',
    it: 'Via Čebelarska 12, 1000 Ljubljana',
    uk: 'Вулиця Чебеларська 12, 1000 Любляна',
    ru: 'Улица Чебеларска 12, 1000 Любляна',
  },
  'contact.form.title': {
    sl: 'Pošljite poizvedbo',
    en: 'Send an Inquiry',
    fr: 'Envoyer une Demande',
    de: 'Anfrage Senden',
    it: 'Invia una Richiesta',
    uk: 'Надіслати Запит',
    ru: 'Отправить Запрос',
  },
  'contact.hours.title': {
    sl: 'Delovni čas',
    en: 'Working Hours',
    fr: "Heures d'Ouverture",
    de: 'Öffnungszeiten',
    it: 'Orari di Lavoro',
    uk: 'Робочі Години',
    ru: 'Рабочие Часы',
  },
  'contact.hours.weekday': {
    sl: 'Ponedeljek - Petek:',
    en: 'Monday - Friday:',
    fr: 'Lundi - Vendredi:',
    de: 'Montag - Freitag:',
    it: 'Lunedì - Venerdì:',
    uk: "Понеділок - П'ятниця:",
    ru: 'Понедельник - Пятница:',
  },
  'contact.hours.saturday': {
    sl: 'Sobota:',
    en: 'Saturday:',
    fr: 'Samedi:',
    de: 'Samstag:',
    it: 'Sabato:',
    uk: 'Субота:',
    ru: 'Суббота:',
  },
  'contact.hours.sunday': {
    sl: 'Nedelja:',
    en: 'Sunday:',
    fr: 'Dimanche:',
    de: 'Sonntag:',
    it: 'Domenica:',
    uk: 'Неділя:',
    ru: 'Воскресенье:',
  },
  'contact.hours.closed': {
    sl: 'Zaprto',
    en: 'Closed',
    fr: 'Fermé',
    de: 'Geschlossen',
    it: 'Chiuso',
    uk: 'Зачинено',
    ru: 'Закрыто',
  },
  'contact.response.title': {
    sl: 'Hiter odziv',
    en: 'Quick Response',
    fr: 'Réponse Rapide',
    de: 'Schnelle Antwort',
    it: 'Risposta Rapida',
    uk: 'Швидка Відповідь',
    ru: 'Быстрый Ответ',
  },
  'contact.response.description': {
    sl: 'Odgovorimo na vse poizvedbe v 24 urah. Za nujne zadeve nas pokličite.',
    en: 'We respond to all inquiries within 24 hours. For urgent matters, please call us.',
    fr: 'Nous répondons à toutes les demandes dans les 24 heures. Pour les questions urgentes, appelez-nous.',
    de: 'Wir antworten auf alle Anfragen innerhalb von 24 Stunden. Für dringende Angelegenheiten rufen Sie uns bitte an.',
    it: 'Rispondiamo a tutte le richieste entro 24 ore. Per questioni urgenti, chiamaci.',
    uk: 'Ми відповідаємо на всі запити протягом 24 годин. Для термінових питань зателефонуйте нам.',
    ru: 'Мы отвечаем на все запросы в течение 24 часов. По срочным вопросам звоните нам.',
  },
  'contact.personal.title': {
    sl: 'Osebni pristop',
    en: 'Personal Approach',
    fr: 'Approche Personnelle',
    de: 'Persönlicher Ansatz',
    it: 'Approccio Personale',
    uk: 'Особистий Підхід',
    ru: 'Личный Подход',
  },
  'contact.personal.description': {
    sl: 'Vsaki poizvedbi posvetimo pozornost in ponudimo prilagojene rešitve.',
    en: 'We give attention to every inquiry and offer customized solutions.',
    fr: "Nous accordons de l'attention à chaque demande et proposons des solutions personnalisées.",
    de: 'Wir schenken jeder Anfrage Aufmerksamkeit und bieten maßgeschneiderte Lösungen.',
    it: 'Diamo attenzione a ogni richiesta e offriamo soluzioni personalizzate.',
    uk: 'Ми приділяємо увагу кожному запиту та пропонуємо індивідуальні рішення.',
    ru: 'Мы уделяем внимание каждому запросу и предлагаем индивидуальные решения.',
  },
  'contact.visit.title': {
    sl: 'Obiščite nas',
    en: 'Visit Us',
    fr: 'Visitez-nous',
    de: 'Besuchen Sie Uns',
    it: 'Visitaci',
    uk: 'Відвідайте Нас',
    ru: 'Посетите Нас',
  },
  'contact.visit.description': {
    sl: 'Vabljeni na osebni obisk naše čebelarije. Oglejte si našo proizvodnjo in poskusite naše izdelke.',
    en: 'You are welcome to visit our beekeeping. See our production and try our products.',
    fr: 'Vous êtes les bienvenus pour visiter notre apiculture. Découvrez notre production et essayez nos produits.',
    de: 'Sie sind herzlich eingeladen, unsere Imkerei zu besuchen. Sehen Sie unsere Produktion und probieren Sie unsere Produkte.',
    it: 'Sei il benvenuto a visitare la nostra apicoltura. Guarda la nostra produzione e prova i nostri prodotti.',
    uk: 'Ласкаво просимо відвідати нашу пасіку. Подивіться на наше виробництво та спробуйте наші продукти.',
    ru: 'Добро пожаловать посетить нашу пасеку. Посмотрите на наше производство и попробуйте наши продукты.',
  },
};

export function t(key: TranslationKey, lang: Language): string {
  return translations[key]?.[lang] || translations[key]?.['en'] || key;
}
